import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, finalize, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private snackbar: MatSnackBar, private toastr: ToastrService) {

  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Siva Added for #MD4FRON-6700

    // if (!window.navigator.onLine) {
    //   const error = {
    //     status: 0,
    //     error: {
    //       description: 'Check Connectivity!'
    //     },
    //     statusText: 'Check Connectivity!'
    //   };
    //  // return throwError(new HttpErrorResponse(error));
    // } 
    // End Changes
    return next.handle(request)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
          return event;
        }),
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error != null && error != undefined) {
            //// Siva Added for #MD4FRON-6700
            if (error.status === 0) {
              const error = {
                status: 0,
                error: {
                  description: 'Check Connectivity!'
                },
                statusText: 'Check Connectivity!'
              };
              return throwError(new HttpErrorResponse(error));
              // this.toastr.error("No Internet Connectivity");
              // return throwError("No Internet Connectivity");
            }
            // End Changes       
            if (error.error instanceof ErrorEvent) {
              // client-side error
              if (error.error != null && error.error != undefined) {
                errorMessage = `Error: ${error.error.message}`;
                console.log("Error" + error.error);
              }
            } else {
              // server-side error
              if (error.error != null && error.error != undefined) {
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.Message}`;
                console.log("Error" + error.error.Message);
              }
            }
            if (error.error != null && error.error != undefined) {
              console.log(error.error);
              if (error.error.error_description != null && error.error.error_description != undefined)
                this.toastr.error(error.error.error_description);
              // this.snackbar.open(error.error.Message, 'close', {
              //   duration: 3000
              // });
            }
          }
          return throwError(errorMessage);
        }),


      )
  }
}
